export default "__VITE_ASSET__BZIqVZk9__"